export default "/images/twitter.svg?410a9d14144a810542330f7d951ff2cf";